module.exports = __webpack_public_path__ + "img/Jurisdiction.860cf118.png";